<template>
  <div class="list-card-wrap v-scroll-item relative-position sticky-wrap matc-type-card" v-if="selectedMarket!=market.earlyMarket.key"
    style="height: 38px !important;" :style="getTop()" @click="showMarketMatches(marketType)">
    <div class="list-card-inner">
      <div class="match-type text-left yb-flex-between" v-if='(sortedEventList && Object.keys(sortedEventList).length > 0) || (sortedRBEventList && Object.keys(sortedRBEventList).length > 0)' 
        :class="[marketType==market.inPlayMarket.key ? 'match-type-odd':'match-type-even']">
        <div class="col-left">
          <template v-if="marketType==market.inPlayMarket.key">
            {{ sportTableLang.table['SPORT_TABLE.LBL_INPLAY'] }}
            <span class="match-number"> {{ sortedRBEventList.length }}</span>
          </template>
          <template v-else>
            {{ sportTableLang.table['SPORT_TABLE.LBL_NOT_STARTED'] }}
            <span class="match-number"> {{ sortedEventList.length }}</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import EventBus from '../../events/event-bus'
// import DateFilter from '@/vue/filters/date'

export default {
  // mixins: [],
  props: {
    marketType: null,
  },
  components: {
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'sortedEventList',
      'sortedRBEventList',
      'selectedBettype',
      'selectedMarket',
      'market',
    ])
  },
  data() {
    return {
      reloading: false,
    }
  },
  methods: {
    showMarketMatches(mrkt){
      var isRB = (mrkt==this.market.inPlayMarket.key) ? true:false
      this.$emit('updateMethod', isRB)
    },
    getTop(){
      var topVal = (this.selectedMarket == this.$store.getters.market.tdyMarket.key  && (this.$store.getters.selectedBettype.betTypId != 5 || !this.isParlayTab) ) ? '35.5' : '85.5'
      if(this.selectedMarket == this.$store.getters.market.hotSportMarket.key && this.$store.getters.showFavEvents){
        topVal = '35.5'
      }
      return 'top:'+topVal+'px'
    },
  },
  destroyed() {
    EventBus.$off("updateMethod");
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/todayHeader.vue